module.exports = __webpack_public_path__ + "static/media/dashboards.6e329aae.svg";